
import InputFieldMixin from '~/components/Inputs/_InputFieldMixin';
import { PropType, defineComponent } from 'vue';

export default defineComponent({
  name: 'SelectInput',

  mixins: [InputFieldMixin],

  props: {
    menuProps: { type: Object, default: () => ({ bottom: true, offsetY: true }) },
    rules: { type: Array as PropType<Array<() => boolean | string>>, default: () => [] },
    hideDropdownIcon: { type: Boolean, default: false },
    blurOnClear: { type: Boolean, default: false },
  },

  computed: {
    appendIcon(): string {
      return this.hideDropdownIcon ? '' : '$dropdown';
    },

    mergedRules() {
      return [this.isRequired, ...this.rules];
    },
  },

  methods: {
    onClear() {
      this.$emit('click:clear');
      if (this.blurOnClear) (this.$refs.select as HTMLElement).blur();
    },
  },
});
